module.exports = __webpack_public_path__ + "static/img/bcg.61af0413.webp";